<template>
  <div class="home-view">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-blob hero-blob-blue"></div>
      <div class="hero-blob hero-blob-orange"></div>
      <div class="hero-blob hero-blob-small"></div>
      <div class="hero-grid-pattern"></div>

      <div class="hero-content">
        <span class="hero-eyebrow">EPRINTTOOLS · 印前智能工具集</span>
        <h1 class="hero-title">印前设计 · <span class="hero-title-accent">智能高效</span></h1>
        <p class="hero-subtitle">面向包装印刷与设计师的专业工具集，从设计创作到生产就绪，全流程智能化解决方案，让每一次设计更精准、更高效</p>
        <div class="hero-actions">
          <button class="cta-button" @click="goToPluginDetails(6)">
            <span>查看详情</span>
            <el-icon class="cta-icon"><ArrowRight /></el-icon>
          </button>
          <button class="cta-button-secondary" @click="$router.push('/solutions')">
            <span>探索解决方案</span>
            <el-icon class="cta-icon"><ArrowRight /></el-icon>
          </button>
        </div>

        <div class="hero-stats">
          <div class="hero-stat">
            <div class="hero-stat-num">10+</div>
            <div class="hero-stat-label">专业插件</div>
          </div>
          <div class="hero-stat-divider"></div>
          <div class="hero-stat">
            <div class="hero-stat-num">4</div>
            <div class="hero-stat-label">解决方案</div>
          </div>
          <div class="hero-stat-divider"></div>
          <div class="hero-stat">
            <div class="hero-stat-num">99%</div>
            <div class="hero-stat-label">自动化率</div>
          </div>
        </div>
      </div>
    </section>


    <!-- 精选工具 -->
    <section class="tools-section">
      <div class="tools-section-inner">
        <div class="section-header">
          <h2 class="section-title">
            <span class="gradient-text">精选工具</span>
          </h2>
          <p class="section-subtitle">为包装印刷行业精心打造的专业工具集</p>
          <div class="section-divider"></div>
        </div>

        <div class="tools-grid">
          <!-- 卡片 1：企业级二维码插件 -->
          <div
              class="tool-card hover-lift group"
              @click="goToPluginDetails(2)"
              style="--card-delay: 0s"
          >
            <div class="tool-badge tool-badge--hot">热门</div>
            <div class="tool-image-wrap">
              <img
                  :src="compressedPluginList[0]?.compressedImage || ''"
                  alt="企业级二维码插件"
                  class="tool-image"
                  @load="onPluginImageLoad(2)"
              />
              <div class="tool-image-overlay"></div>
              <div class="tool-image-icon">
                <div class="tool-icon-circle tool-icon-circle--blue">
                  <el-icon><Grid /></el-icon>
                </div>
              </div>
            </div>
            <div class="tool-body">
              <h3 class="tool-name">企业级二维码插件</h3>
              <p class="tool-desc">批量生成、自定义样式、一键导出</p>
              <div class="tool-action">
                <span class="tool-action-label tool-action-label--blue">了解详情</span>
                <div class="tool-action-arrow tool-action-arrow--blue">
                  <el-icon><ArrowRight /></el-icon>
                </div>
              </div>
            </div>
            <div class="tool-bar tool-bar--blue"></div>
          </div>

          <!-- 卡片 2：智能刀模生成插件 -->
          <div
              class="tool-card hover-lift group"
              @click="goToPluginDetails(3)"
              style="--card-delay: 0.1s"
          >
            <div class="tool-badge tool-badge--pro">专业</div>
            <div class="tool-image-wrap">
              <img
                  :src="compressedPluginList[1]?.compressedImage || ''"
                  alt="智能刀模生成插件"
                  class="tool-image"
                  @load="onPluginImageLoad(3)"
              />
              <div class="tool-image-overlay"></div>
              <div class="tool-image-icon">
                <div class="tool-icon-circle tool-icon-circle--orange">
                  <el-icon><Share /></el-icon>
                </div>
              </div>
            </div>
            <div class="tool-body">
              <h3 class="tool-name">智能刀模生成插件</h3>
              <p class="tool-desc">智能识别轮廓、自动优化排版</p>
              <div class="tool-action">
                <span class="tool-action-label tool-action-label--orange">了解详情</span>
                <div class="tool-action-arrow tool-action-arrow--orange">
                  <el-icon><ArrowRight /></el-icon>
                </div>
              </div>
            </div>
            <div class="tool-bar tool-bar--orange"></div>
          </div>

          <!-- 卡片 3：智能能效标签管理插件 -->
          <div
              class="tool-card hover-lift group"
              @click="goToPluginDetails(4)"
              style="--card-delay: 0.2s"
          >
            <div class="tool-badge tool-badge--rec">推荐</div>
            <div class="tool-image-wrap">
              <img
                  :src="compressedPluginList[2]?.compressedImage || ''"
                  alt="智能能效标签管理插件"
                  class="tool-image"
                  @load="onPluginImageLoad(4)"
              />
              <div class="tool-image-overlay"></div>
              <div class="tool-image-icon">
                <div class="tool-icon-circle tool-icon-circle--indigo">
                  <el-icon><DataAnalysis /></el-icon>
                </div>
              </div>
            </div>
            <div class="tool-body">
              <h3 class="tool-name">智能能效标签管理插件</h3>
              <p class="tool-desc">标准合规、智能填充、批量处理</p>
              <div class="tool-action">
                <span class="tool-action-label tool-action-label--indigo">了解详情</span>
                <div class="tool-action-arrow tool-action-arrow--indigo">
                  <el-icon><ArrowRight /></el-icon>
                </div>
              </div>
            </div>
            <div class="tool-bar tool-bar--indigo"></div>
          </div>

          <!-- 卡片 4：美国版能效标签插件 -->
          <div
              class="tool-card hover-lift group"
              @click="goToPluginDetails(5)"
              style="--card-delay: 0.3s"
          >
            <div class="tool-badge tool-badge--new">新品</div>
            <div class="tool-image-wrap">
              <img
                  :src="compressedPluginList[3]?.compressedImage || ''"
                  alt="美国版能效标签插件"
                  class="tool-image"
                  @load="onPluginImageLoad(5)"
              />
              <div class="tool-image-overlay"></div>
              <div class="tool-image-icon">
                <div class="tool-icon-circle tool-icon-circle--warm">
                  <el-icon><CollectionTag /></el-icon>
                </div>
              </div>
            </div>
            <div class="tool-body">
              <h3 class="tool-name">美国版能效标签插件</h3>
              <p class="tool-desc">FTC合规、多语言、自动计算</p>
              <div class="tool-action">
                <span class="tool-action-label tool-action-label--warm">了解详情</span>
                <div class="tool-action-arrow tool-action-arrow--warm">
                  <el-icon><ArrowRight /></el-icon>
                </div>
              </div>
            </div>
            <div class="tool-bar tool-bar--warm"></div>
          </div>
        </div>
      </div>
    </section>


    <!-- 解决方案 (全新样式，与 HTML 一致) -->
    <section class="solutions-section">
      <div class="solutions-section-bg"></div>
      <div class="solutions-section-inner">
        <div class="section-header">
          <h2 class="section-title">
            <span class="gradient-text">解决方案</span>
          </h2>
          <p class="section-subtitle">覆盖包装印刷全链路的专业解决方案</p>
          <div class="section-divider"></div>
        </div>

        <div class="solutions-grid">
          <!-- 解决方案 1：设计与创作 -->
          <div
              class="solution-card hover-lift group"
              @click="$router.push('/solutions')"
              style="--card-delay: 0s"
          >
            <div class="solution-top-bar solution-top-bar--blue"></div>
            <div class="solution-icon solution-icon--blue">
              <el-icon><Edit /></el-icon>
            </div>
            <h3 class="solution-title">设计与创作</h3>
            <p class="solution-desc">专业的包装设计、3D建模和创意工具，提升设计效率</p>
            <div class="solution-arrow">
              <div class="solution-arrow-circle solution-arrow-circle--blue">
                <el-icon><ArrowRight /></el-icon>
              </div>
            </div>
          </div>

          <!-- 解决方案 2：质量验证 -->
          <div
              class="solution-card hover-lift group"
              @click="$router.push('/solutions')"
              style="--card-delay: 0.1s"
          >
            <div class="solution-top-bar solution-top-bar--orange"></div>
            <div class="solution-icon solution-icon--orange">
              <el-icon><Check /></el-icon>
            </div>
            <h3 class="solution-title">质量验证</h3>
            <p class="solution-desc">自动化校验、能效标签验证和合规性检查工具</p>
            <div class="solution-arrow">
              <div class="solution-arrow-circle solution-arrow-circle--orange">
                <el-icon><ArrowRight /></el-icon>
              </div>
            </div>
          </div>

          <!-- 解决方案 3：生产就绪 -->
          <div
              class="solution-card hover-lift group"
              @click="$router.push('/solutions')"
              style="--card-delay: 0.2s"
          >
            <div class="solution-top-bar solution-top-bar--rose"></div>
            <div class="solution-icon solution-icon--rose">
              <el-icon><Setting /></el-icon>
            </div>
            <h3 class="solution-title">生产就绪</h3>
            <p class="solution-desc">智能刀模、工艺文件和印刷就绪解决方案</p>
            <div class="solution-arrow">
              <div class="solution-arrow-circle solution-arrow-circle--rose">
                <el-icon><ArrowRight /></el-icon>
              </div>
            </div>
          </div>

          <!-- 解决方案 4：流程自动化 -->
          <div
              class="solution-card hover-lift group"
              @click="$router.push('/solutions')"
              style="--card-delay: 0.3s"
          >
            <div class="solution-top-bar solution-top-bar--purple"></div>
            <div class="solution-icon solution-icon--purple">
              <el-icon><Opportunity /></el-icon>
            </div>
            <h3 class="solution-title">流程自动化</h3>
            <p class="solution-desc">工作流自动化、批量处理和系统集成方案</p>
            <div class="solution-arrow">
              <div class="solution-arrow-circle solution-arrow-circle--purple">
                <el-icon><ArrowRight /></el-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import {
  ArrowRight,
  Edit,
  Check,
  Setting,
  Opportunity,
  Grid,
  Scissor,
  DataAnalysis,
  CollectionTag
} from '@element-plus/icons-vue';

export default {
  name: 'HomeView',

  components: {
    ArrowRight,
    Edit,
    Check,
    Setting,
    Opportunity,
    Grid,
    Scissor,
    DataAnalysis,
    CollectionTag
  },

  setup() {
    const router = useRouter();

    const homeImageLoaded = ref(false);
    const compressedHomeImage = ref('');

    const pluginList = reactive([
      {
        id: 2,
        name: '企业级二维码插件',
        image: 'https://test.eprinttools.com/files/front-end/code.gif',
        compressedImage: 'https://test.eprinttools.com/files/front-end/code.gif',
        imageLoaded: false
      },
      {
        id: 3,
        name: '智能刀模生成插件',
        image: 'https://test.eprinttools.com/files/front-end/mo.gif',
        compressedImage: 'https://test.eprinttools.com/files/front-end/mo.gif',
        imageLoaded: false
      },
      {
        id: 4,
        name: '智能能效标签管理插件',
        image: 'https://test.eprinttools.com/files/front-end/neng.gif',
        compressedImage: 'https://test.eprinttools.com/files/front-end/neng.gif',
        imageLoaded: false
      },
      {
        id: 5,
        name: '美国版能效标签插件',
        image: 'https://test.eprinttools.com/files/front-end/huang.gif',
        compressedImage: 'https://test.eprinttools.com/files/front-end/huang.gif',
        imageLoaded: false
      }
    ]);

    const loadAndCompressHomeImage = async () => {
      try {
        const imageUrl = 'https://test.eprinttools.com/files/front-end/home1.png';
        compressedHomeImage.value = imageUrl;
        const img = new Image();
        img.onload = () => {
          homeImageLoaded.value = true;
        };
        img.src = imageUrl;
      } catch (error) {
        console.error('首页图片加载失败:', error);
        compressedHomeImage.value = 'https://test.eprinttools.com/files/front-end/home1.png';
        homeImageLoaded.value = true;
      }
    };

    const loadAndCompressPluginImages = async () => {
      try {
        pluginList.forEach(plugin => {
          plugin.compressedImage = plugin.image;
        });
      } catch (error) {
        console.error('插件图片加载失败:', error);
        pluginList.forEach(plugin => {
          plugin.compressedImage = plugin.image;
        });
      }
    };

    const onHomeImageLoad = () => {
      homeImageLoaded.value = true;
    };

    const onPluginImageLoad = (pluginId) => {
      const plugin = pluginList.find(p => p.id === pluginId);
      if (plugin) {
        plugin.imageLoaded = true;
      }
    };

    const compressedPluginList = pluginList;

    const goToPluginDetails = (pluginId) => {
      router.push({
        path: '/products',
        query: { id: pluginId }
      });
    };

    onMounted(async () => {
      loadAndCompressHomeImage();
      loadAndCompressPluginImages();
    });

    return {
      homeImageLoaded,
      compressedHomeImage,
      compressedPluginList,
      onHomeImageLoad,
      onPluginImageLoad,
      goToPluginDetails
    };
  }
};
</script>

<style scoped>
/* ============ Root ============ */
.home-view {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: #0f172a;
  background: radial-gradient(ellipse 900px 600px at 10% 5%, rgba(59, 130, 246, 0.10), transparent 55%),
  radial-gradient(ellipse 800px 500px at 90% 15%, rgba(249, 115, 22, 0.08), transparent 55%),
  radial-gradient(ellipse 700px 500px at 30% 45%, rgba(96, 165, 250, 0.07), transparent 55%),
  radial-gradient(ellipse 600px 400px at 75% 70%, rgba(251, 146, 60, 0.06), transparent 55%),
  radial-gradient(ellipse 800px 500px at 50% 95%, rgba(59, 130, 246, 0.06), transparent 55%),
  #f6f8fc;
  background-attachment: fixed;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
}

/* ============ Hero (保持不变) ============ */
.hero-section {
  position: relative;
  padding: 110px 20px 90px;
  overflow: hidden;
  background: transparent;
}

.hero-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.6;
  pointer-events: none;
  animation: blobFloat 14s ease-in-out infinite;
}

.hero-blob-blue {
  width: 480px;
  height: 480px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.42), transparent 70%);
  top: -140px;
  left: -100px;
}

.hero-blob-orange {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(249, 115, 22, 0.38), transparent 70%);
  top: 20px;
  right: -80px;
  animation-delay: -5s;
}

.hero-blob-small {
  width: 260px;
  height: 260px;
  background: radial-gradient(circle, rgba(96, 165, 250, 0.32), transparent 70%);
  bottom: -80px;
  left: 38%;
  animation-delay: -9s;
}

@keyframes blobFloat {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(24px, -32px) scale(1.06);
  }
}

.hero-grid-pattern {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(59, 130, 246, 0.04) 1px, transparent 1px),
  linear-gradient(90deg, rgba(59, 130, 246, 0.04) 1px, transparent 1px);
  background-size: 48px 48px;
  mask-image: radial-gradient(ellipse 80% 60% at 50% 40%, #000 30%, transparent 75%);
  pointer-events: none;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 1100px;
  margin: 0 auto;
  text-align: center;
  animation: fadeInUp 0.9s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.hero-eyebrow {
  display: inline-block;
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.18em;
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.08);
  padding: 7px 18px;
  border-radius: 100px;
  margin-bottom: 24px;
  border: 1px solid rgba(59, 130, 246, 0.18);
}

.hero-title {
  font-size: clamp(2.4rem, 6vw, 4.5rem);
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
  margin: 0 0 24px;
  background: linear-gradient(135deg, #1e293b 0%, #3b82f6 60%, #f97316 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-title-accent {
  background: linear-gradient(135deg, #3b82f6 0%, #f97316 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 1.12rem;
  color: #475569;
  max-width: 680px;
  margin: 0 auto 40px;
  line-height: 1.7;
}

.hero-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 64px;
}

.cta-button {
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
  color: white;
  font-weight: 600;
  border: none;
  padding: 16px 36px;
  font-size: 1.05rem;
  border-radius: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 12px 28px rgba(59, 130, 246, 0.35);
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.cta-button:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 38px rgba(59, 130, 246, 0.45);
}

.cta-button .cta-icon {
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  font-size: 1rem;
}

.cta-button:hover .cta-icon {
  transform: translateX(4px);
}

.cta-button-secondary {
  background: white;
  color: #3b82f6;
  font-weight: 600;
  border: 1px solid rgba(59, 130, 246, 0.3);
  padding: 16px 32px;
  font-size: 1.05rem;
  border-radius: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: background 0.4s ease, border-color 0.4s ease, transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.cta-button-secondary:hover {
  background: rgba(59, 130, 246, 0.06);
  border-color: #3b82f6;
  transform: translateY(-4px);
}

.cta-button-secondary .cta-icon {
  font-size: 1rem;
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.cta-button-secondary:hover .cta-icon {
  transform: translateX(4px);
}

.hero-stats {
  display: flex;
  gap: 36px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.hero-stat-num {
  font-size: 2.3rem;
  font-weight: 800;
  line-height: 1;
  background: linear-gradient(135deg, #3b82f6 0%, #f97316 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-stat-label {
  font-size: 0.88rem;
  color: #475569;
  margin-top: 6px;
  letter-spacing: 0.04em;
}

.hero-stat-divider {
  width: 1px;
  height: 36px;
  background: linear-gradient(180deg, transparent, rgba(59, 130, 246, 0.25), transparent);
}

/* ============ 通用 Section Header ============ */
.section-header {
  text-align: center;
  margin-bottom: 56px;
}

.section-title {
  font-size: clamp(1.875rem, 4vw, 2.25rem);
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.025em;
}

.gradient-text {
  background: linear-gradient(135deg, #6296ea 0%, #72a2f1 60%, #f97316 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  font-size: 1rem;
  color: #64748b;
  max-width: 600px;
  margin: 16px auto 0;
  line-height: 1.6;
}

.section-divider {
  width: 128px;
  height: 1px;
  margin: 24px auto 0;
  background: linear-gradient(90deg, #0000, #0ea5e933, #f9731626, #0000);
}

/* 精选工具 — 全新样式 */
.tools-section {
  padding: 80px 0;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.tools-section::before {
  content: '';
  position: absolute;
  top: 40px;
  left: -10%;
  width: 50%;
  height: 400px;
  background: radial-gradient(ellipse, rgba(59, 130, 246, 0.08), transparent 70%);
  filter: blur(40px);
  pointer-events: none;
  z-index: 0;
}

.tools-section-inner {
  position: relative;
  z-index: 1;
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

/* —— 工具卡片 —— */
.tool-card {
  position: relative;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(226, 232, 240, 0.5);
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  animation-delay: var(--card-delay, 0s);
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1),
  box-shadow 0.4s cubic-bezier(0.16, 1, 0.3, 1),
  border-color 0.3s ease;
}

.tool-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.10), 0 4px 16px rgba(59, 130, 246, 0.08);
  border-color: rgba(59, 130, 246, 0.20);
}

/* —— 角标 —— */
.tool-badge {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 10;
  padding: 4px 14px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.tool-badge--hot {
  background: linear-gradient(to right, #3b82f6, #60a5fa);
}
.tool-badge--pro {
  background: linear-gradient(to right, #f97316, #fb923c);
}
.tool-badge--rec {
  background: linear-gradient(to right, #6366f1, #818cf8);
}
.tool-badge--new {
  background: linear-gradient(to right, #10b981, #34d399);
}

/* —— 图片区域 —— */
.tool-image-wrap {
  position: relative;
  width: 100%;
  height: 192px;
  overflow: hidden;
  background: linear-gradient(to bottom right, #eff6ff, #fff7ed);
}

.tool-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.tool-card:hover .tool-image {
  transform: scale(1.10);
}

/* 白色蒙层 (悬停) */
.tool-image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(255, 255, 255, 0.94), transparent 50%);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 1;
}

.tool-card:hover .tool-image-overlay {
  opacity: 1;
}

/* 底部图标 (悬停出现) */
.tool-image-icon {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%) translateY(16px);
  z-index: 2;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.tool-card:hover .tool-image-icon {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

.tool-icon-circle {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.2rem;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.20);
}

.tool-icon-circle--blue {
  background: linear-gradient(to bottom right, #3b82f6, #60a5fa);
}
.tool-icon-circle--orange {
  background: linear-gradient(to bottom right, #f97316, #fb923c);
}
.tool-icon-circle--indigo {
  background: linear-gradient(to bottom right, #6366f1, #818cf8);
}
.tool-icon-circle--warm {
  background: linear-gradient(to bottom right, #ea580c, #fb923c);
}

/* —— 内容区 —— */
.tool-body {
  padding: 18px 20px 20px;
}

.tool-name {
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 4px;
  transition: color 0.3s ease;
}

.tool-card:hover .tool-name {
  color: #2563eb;
}

.tool-desc {
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.6;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* —— 底部操作行 —— */
.tool-action {
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tool-action-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 0.72rem;
  font-weight: 500;
}

.tool-action-label--blue {
  background: #eff6ff;
  color: #2563eb;
}
.tool-action-label--orange {
  background: #fff7ed;
  color: #ea580c;
}
.tool-action-label--indigo {
  background: #eef2ff;
  color: #4f46e5;
}
.tool-action-label--warm {
  background: #fffbeb;
  color: #d97706;
}

.tool-action-arrow {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.tool-action-arrow--blue {
  background: #eff6ff;
  color: #3b82f6;
}
.tool-action-arrow--orange {
  background: #fff7ed;
  color: #f97316;
}
.tool-action-arrow--indigo {
  background: #eef2ff;
  color: #6366f1;
}
.tool-action-arrow--warm {
  background: #fffbeb;
  color: #d97706;
}

.tool-card:hover .tool-action-arrow {
  opacity: 1;
}

.tool-card:hover .tool-action-arrow--blue {
  background: #3b82f6;
  color: #fff;
}
.tool-card:hover .tool-action-arrow--orange {
  background: #f97316;
  color: #fff;
}
.tool-card:hover .tool-action-arrow--indigo {
  background: #6366f1;
  color: #fff;
}
.tool-card:hover .tool-action-arrow--warm {
  background: #d97706;
  color: #fff;
}

/* —— 底部色条 —— */
.tool-bar {
  height: 2px;
  width: 100%;
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.tool-bar--blue {
  background: linear-gradient(to right, #3b82f6, #60a5fa);
}
.tool-bar--orange {
  background: linear-gradient(to right, #f97316, #fb923c);
}
.tool-bar--indigo {
  background: linear-gradient(to right, #6366f1, #818cf8);
}
.tool-bar--warm {
  background: linear-gradient(to right, #d97706, #fbbf24);
}

.tool-card:hover .tool-bar {
  transform: scaleX(1);
}


/* 解决方案 */
.solutions-section {
  padding: 80px 0 100px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.solutions-section-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.solutions-section::before {
  content: '';
  position: absolute;
  top: 20px;
  right: -10%;
  width: 55%;
  height: 450px;
  background: radial-gradient(ellipse, rgba(249, 115, 22, 0.07), transparent 70%);
  filter: blur(40px);
  pointer-events: none;
  z-index: 0;
}

.solutions-section-inner {
  position: relative;
  z-index: 1;
}

.solutions-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

/* —— 解决方案卡片 —— */
.solution-card {
  position: relative;
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 28px 32px;
  border: 1px solid rgba(226, 232, 240, 0.5);
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.04);
  cursor: pointer;
  overflow: hidden;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  animation-delay: var(--card-delay, 0s);
  transition: transform 0.8s cubic-bezier(0.16, 1, 0.3, 1),
  box-shadow 0.8s cubic-bezier(0.16, 1, 0.3, 1),
  border-color 0.7s ease;
}

.solution-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.10), 0 4px 16px rgba(59, 130, 246, 0.08);
  border-color: rgba(59, 130, 246, 0.20);
}

/* —— 顶部色条 —— */
.solution-top-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  transform: scaleX(0);
  transform-origin: left center;
  transition: transform 0.9s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 2;
}

.solution-top-bar--blue {
  background: linear-gradient(to right, #3b82f6, #60a5fa);
}
.solution-top-bar--orange {
  background: linear-gradient(to right, #f97316, #fb923c);
}
.solution-top-bar--rose {
  background: linear-gradient(to right, #f43f5e, #fb7185);
}
.solution-top-bar--purple {
  background: linear-gradient(to right, #8b5cf6, #a78bfa);
}

.solution-card:hover .solution-top-bar {
  transform: scaleX(1);
}

/* —— 图标 —— */
.solution-icon {
  width: 68px;
  height: 68px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.6rem;
  margin-bottom: 24px;
  transition: transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  z-index: 1;
}

.solution-icon--blue {
  background: linear-gradient(to bottom right, #3b82f6, #60a5fa);
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.30);
}
.solution-icon--orange {
  background: linear-gradient(to bottom right, #f97316, #fb923c);
  box-shadow: 0 8px 20px rgba(249, 115, 22, 0.30);
}
.solution-icon--rose {
  background: linear-gradient(to bottom right, #f43f5e, #fb7185);
  box-shadow: 0 8px 20px rgba(244, 63, 94, 0.30);
}
.solution-icon--purple {
  background: linear-gradient(to bottom right, #8b5cf6, #a78bfa);
  box-shadow: 0 8px 20px rgba(139, 92, 246, 0.30);
}

.solution-card:hover .solution-icon {
  transform: scale(1.10) rotate(3deg);
}

/* —— 标题 & 描述 —— */
.solution-title {
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0 0 12px;
  color: #0f172a;
  position: relative;
  z-index: 1;
}

.solution-desc {
  font-size: 0.875rem;
  color: #64748b;
  line-height: 1.7;
  margin: 0 0 24px;
  position: relative;
  z-index: 1;
}

/* —— 箭头 —— */
.solution-arrow {
  position: relative;
  z-index: 1;
}

.solution-arrow-circle {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  transition: all 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

.solution-arrow-circle--blue {
  background: #eff6ff;
  color: #3b82f6;
}
.solution-arrow-circle--orange {
  background: #fff7ed;
  color: #f97316;
}
.solution-arrow-circle--rose {
  background: #fff1f2;
  color: #f43f5e;
}
.solution-arrow-circle--purple {
  background: #f5f3ff;
  color: #8b5cf6;
}

.solution-card:hover .solution-arrow-circle--blue {
  background: #3b82f6;
  color: #fff;
  transform: translateX(4px);
}
.solution-card:hover .solution-arrow-circle--orange {
  background: #f97316;
  color: #fff;
  transform: translateX(4px);
}
.solution-card:hover .solution-arrow-circle--rose {
  background: #f43f5e;
  color: #fff;
  transform: translateX(4px);
}
.solution-card:hover .solution-arrow-circle--purple {
  background: #8b5cf6;
  color: #fff;
  transform: translateX(4px);
}

/* 动画 */
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式 */
@media (max-width: 1200px) {
  .tools-grid,
  .solutions-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 22px;
  }

  .hero-section {
    padding: 90px 20px 100px;
  }
}

@media (max-width: 768px) {
  .hero-section {
    padding: 60px 20px 70px;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .hero-actions {
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 48px;
  }

  .cta-button,
  .cta-button-secondary {
    width: 100%;
    max-width: 320px;
    margin: 0 auto;
    justify-content: center;
  }

  .hero-stats {
    gap: 20px;
  }
  .hero-stat-num {
    font-size: 1.7rem;
  }
  .hero-stat-label {
    font-size: 0.8rem;
  }
  .hero-stat-divider {
    display: none;
  }

  .tools-section,
  .solutions-section {
    padding: 50px 16px;
  }
  .solutions-section {
    padding-bottom: 70px;
  }

  .tools-grid,
  .solutions-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .tool-image-wrap {
    height: 200px;
  }

  .solution-card {
    padding: 28px 22px;
  }
  .solution-icon {
    width: 72px;
    height: 72px;
    margin-bottom: 20px;
    font-size: 1.8rem;
  }
}

@media (max-width: 576px) {
  .hero-section {
    padding: 50px 16px 60px;
  }

  .hero-eyebrow {
    font-size: 0.72rem;
    padding: 6px 14px;
  }
  .hero-actions {
    margin-bottom: 40px;
  }
  .cta-button,
  .cta-button-secondary {
    padding: 14px 24px;
    font-size: 0.98rem;
  }
  .hero-stats {
    gap: 14px;
  }
  .hero-stat-num {
    font-size: 1.5rem;
  }

  .tool-body {
    padding: 14px 16px 16px;
  }
  .tool-name {
    font-size: 0.95rem;
  }

  .solution-card {
    padding: 24px 18px;
  }
  .solution-title {
    font-size: 1.05rem;
  }
  .solution-desc {
    font-size: 0.85rem;
  }
}

@media (min-width: 1440px) {
  .tools-section,
  .solutions-section {
    max-width: 1200px;
  }
  .hero-content {
    max-width: 1200px;
  }
}
</style>